import Typography from '@mui/material/Typography'
import Link from 'next/link'

interface TelProps {
    tel: string
}

const Tel = ({ tel }: TelProps) => {
    return (
        <Link
            href={tel}
            style={{ textDecoration: 'none', color: 'black', minWidth: 'fit-content' }}
        >
            <Typography
                variant='subtitle2'
                sx={{ fontWeight: 'bold' }}
            >
                {tel.replace('tel:', '')}
            </Typography>
        </Link>
    )
}

export default Tel


